var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0014 19.1467L7.71484 14.8593L8.92621 13.648L12.0014 16.7222L18.504 10.2188L19.7171 11.4318L12.0014 19.1467Z",
    fill: "#0061D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7171 2.50391C11.3433 2.50391 9.02275 3.20782 7.049 4.52665C5.07524 5.84547 3.53688 7.71996 2.62846 9.91308C1.72004 12.1062 1.48236 14.5195 1.94547 16.8477C2.40858 19.1759 3.55168 21.3145 5.23022 22.993C6.90876 24.6715 9.04736 25.8146 11.3756 26.2777C13.7038 26.7409 16.117 26.5032 18.3101 25.5947C20.5033 24.6863 22.3777 23.148 23.6966 21.1742C25.0154 19.2005 25.7193 16.88 25.7193 14.5061C25.7193 11.3229 24.4548 8.27013 22.2039 6.01928C19.9531 3.76842 16.9003 2.50391 13.7171 2.50391ZM13.7171 24.7938C11.6824 24.7938 9.69337 24.1904 8.00158 23.06C6.30979 21.9296 4.9912 20.3229 4.21255 18.443C3.43391 16.5632 3.23018 14.4947 3.62713 12.4991C4.02408 10.5035 5.00388 8.67044 6.44263 7.23169C7.88138 5.79294 9.71446 4.81313 11.7101 4.41618C13.7057 4.01923 15.7742 4.22296 17.654 5.00161C19.5338 5.78026 21.1405 7.09885 22.2709 8.79064C23.4013 10.4824 24.0047 12.4714 24.0047 14.5061C24.0047 17.2346 22.9208 19.8513 20.9915 21.7806C19.0622 23.7099 16.4455 24.7938 13.7171 24.7938Z",
    fill: "#0061D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c810a6f19171e6dac562c53d8677331c.svg";
export { ForwardRef as ReactComponent };